import React from 'react'
import { Stack } from 'react-bootstrap'

export type CenterScreenProps = { children: React.ReactNode; minHeight?: number }
export const CenterScreen = ({ children, minHeight = 100 }: CenterScreenProps) => {
  return (
    <main>
      <div className="container">
        <Stack className="justify-content-center align-items-center" style={{ minHeight: `${minHeight}vh` }}>
          {children}
        </Stack>
      </div>
    </main>
  )
}
